module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAARgAAAAJCAYAAADpczMGAAAAAXNSR0IArs4c6QAAAP9JREFUaAXt2atuAkEUgOFz9uK4GSQvUAPI9j3WEbLDagIdHoT6qqZJ36TBktri0MgVbNoMTRWQ2WHx/6idc1nxiZOcTCwcBBBA4IaAKezrePR42G43+xulF+no4sYFAQQQ8Ag4J0OJ5NPM7Jsx876nxBtiwHhZCCKAgFdAZSpR+p0Xz4ssy2JvzVmQAXOGwScCCDQS6KroS6s9+DLGPoU6GDAhHXIIIFAvoPLwvzYV9r1ubWLA1PORQQCBZgITp8kun9nl9drEgGkGSBUCCAQEVLWjKuvrtUn/np9coI8UAgggcLeAE/chv8kqSeO0V1VHvfsPNCCAAAIBgbIsf05cEyz+JzPRwQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/common/image/black.png
// module id = 85
// module chunks = 2